module.exports = __webpack_public_path__ + "img/1567251315.8c06a73d.jpg";